module.exports = __webpack_public_path__ + "img/chat-min.2974bf82.png";